// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rHug","colBig":"styles_colBig__3HIDH","colSmall":"styles_colSmall__21rYg"};